export default {"src":"/_next/static/media/logo-chevron-blue.e521d33f.svg","height":9,"width":5,"blurWidth":0,"blurHeight":0};